"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractAuthLink = void 0;
var util_1 = require("../../util");
function extractAuthLink(query) {
    var _a;
    var auth_username = util_1.tryGetValue(query.auth_username);
    if (!auth_username) {
        return;
    }
    var auth_remember_me = ((_a = util_1.tryGetValue(query.auth_remember_me)) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'true';
    var auth_password = util_1.tryGetValue(query.auth_password);
    if (auth_password) {
        return {
            auth_username: auth_username,
            auth_password: auth_password,
            auth_remember_me: auth_remember_me,
        };
    }
    var auth_token = util_1.tryGetValue(query.auth_token);
    if (!auth_password && !auth_token) {
        return;
    }
    if (auth_token) {
        return {
            auth_username: auth_username,
            auth_token: auth_token,
            auth_remember_me: auth_remember_me,
        };
    }
}
exports.extractAuthLink = extractAuthLink;
